import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {Dienststelle} from "../../../../core/model/dienststelle";
import {SectionComponent} from "../../../../shared/components/structure/section/section.component";
import {TypeaheadComponent} from "../../../../shared/components/controls/ui-controls/typeahead/typeahead.component";
import {DienststellenArtEnum} from "../../../../core/model/dienststellen-art.enum";
import {DienststellenService} from "../../../../core/services/apiservices/dienststellen.service";
import {DienststellenSearchResult} from "../../../../core/model/dienststellen-search-result";
import {I18NextPipe} from "@kokos-i18next";
import i18next from "i18next";
import {take} from "rxjs/operators";


@Component({
    selector: 'kokos-ansprechpartner',
    imports: [
        SectionComponent,
        TypeaheadComponent,
        I18NextPipe
    ],
    templateUrl: './ansprechpartner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AnsprechpartnerComponent {


    @Input() dienststelle: Dienststelle | null = null;

    @Output() jobcenterChanged = new EventEmitter<string>();

    @ViewChild('collapseDienststelle', {static: false}) collapseEl!: ElementRef<HTMLElement>;

    readonly DIENSTSTELLE_UNKNOWN = '00000';

    jobcenterList: DienststellenSearchResult[] | null | undefined;
    isCollapsed = true;

    private readonly dienststellenService = inject(DienststellenService);

    dienststelleBekannt(): boolean {
        const nr = this.dienststelle?.dienststellenNummer;
        return !!nr && nr !== this.DIENSTSTELLE_UNKNOWN;
    }


    jobcenterSuchenButtonLabel(): string {
        return this.dienststelleBekannt()
            ? i18next.t('sendmail.prepare.step.search-other-jobcenter')
            : i18next.t('sendmail.prepare.step.search-jobcenter');
    }

    isJobcenter(): boolean {
        const art = this.dienststelle?.dienststellenArt;
        return art === DienststellenArtEnum.GE || art === DienststellenArtEnum.ZKT;
    }

    getDienststellenSearchResult(): void {
        this.isCollapsed = !this.isCollapsed;
        if (this.jobcenterList && this.jobcenterList.length > 0) {
            return;
        }
        this.dienststellenService.getDienststellenList()
            .pipe(take(1))
            .subscribe(result => {
                this.jobcenterList = result ?? [];
            });
    }

    get jobcenterOptions(): { label: string; value: string }[] {
        const list = this.jobcenterList ?? [];
        return list.map(jobc => ({
            label: jobc.daten,
            value: jobc.nummer
        }));
    }


    setJobcenter(sel: any): void {
        this.isCollapsed = true;
        let dienststellenNummer = '';

        if (typeof sel === 'string' && this.isValidDstnr(sel)) {
            dienststellenNummer = sel;
        } else if (this.isValidDstnr(sel?.value)) {
            dienststellenNummer = sel.value;
        }
        
        if (!dienststellenNummer) {
            return;
        }


        const bsCollapse =
            // identisch zu deiner Logik, kein zusätzlicher Fallback
            globalThis.dpl.bs.Collapse.getInstance(this.collapseEl.nativeElement)
            ?? new globalThis.dpl.bs.Collapse(this.collapseEl.nativeElement, {toggle: false});


        bsCollapse.hide();
        this.jobcenterChanged.emit(dienststellenNummer);
    }

    private isValidDstnr(dstnr: string): boolean {
        //5-Ziffern (kann auch mit 0 beginnen)
        return /^\d{5}$/.test(dstnr);
    }
}